namespace Core {

    export interface IChangeDurationPopupScope {
        popupMessage: string;
        popupHeader: string;
        nightsButtonLabel?: string;
        newNightsButtonLabel?: string;
    }

    const template = `
        <lightbox 
            show="showPopup"
            close="close()"
            header-text="popupHeader"
            lightbox-class="lightbox-confirmation-popup"
            >
            <div class="message-container">
                <span ng-bind-html="popupMessage"></span>
                <div class="button-container">
                    <button ng-click="confirm()">{{nightsButtonLabel}}</button>
                    <button ng-click="confirm('changeDuration')">{{newNightsButtonLabel}}</button>
                </div>
            </div>
        </lightbox>
    `;

    export class ChangeDurationPopupService {
        private defaultPopupScope: IChangeDurationPopupScope;

        constructor(
            private basePopupService: Core.BasePopupService,
            $rootScope: ng.IRootScopeService
        ) {
            this.defaultPopupScope = {
                popupMessage: '',
                popupHeader: '',
                nightsButtonLabel: '',
                newNightsButtonLabel: ''
            };
        }



        public showPopup(customScope: IChangeDurationPopupScope): ng.IPromise<any> {
            const defScope = this.defaultPopupScope;
            const popupParams = {
                popupContainer: 'body',
                popupScope: {
                    ...defScope,
                    ...customScope,
                    confirm: function (val) {
                        if (val === 'changeDuration') {
                            TRPCONFIG.Domain.ChangeHotelNightsDuration = true;
                        } else {
                            TRPCONFIG.Domain.ChangeHotelNightsDuration = false;
                        }
                        this.defer.resolve({
                            result: 'confirm'
                        });
                    },
                    close(value?) {
                        this.defer.reject({
                            result: 'close',
                            value
                        });
                        this.$rootScope.$emit('unblock');
                    },
                    cancel(value?) {
                        this.defer.reject({
                            result: 'cancel',
                            value
                        });
                        this.$rootScope.$emit('unblock');
                    }
                }
            };
            return this.basePopupService.showPopup(template, popupParams);
        }
    }

    angular.module('TR').service('changeDurationPopupService', ChangeDurationPopupService);
}
